import { deserializeBuilderAsset, SerializedBuilderAsset } from "../entities/BuilderAsset";
import { deserializeLibraryItem } from "../entities/LibraryItem";
import { deserializeShareItem, ShareItem } from "../entities/ShareItem"
import { BuilderPreferences } from "../entities/BuilderPreferences";
import UserSharePreference from "../entities/UserSharePreference";
import { WebClient } from "./server/WebClient";

export interface SaveShareRequest {
    commentsEnabled: boolean;
    enabled: boolean;
    assetShareId: number;
    assetShareVideoTypeId?: number;
    videoPath?: string;
}

export const ShareService = {
    getSharedAsset: (shareId: string) => WebClient.Get(`api/Share/SharedAsset?shareId=${shareId}`, deserializeBuilderAsset),
    getSharedSlide: (shareId: string) => WebClient.Get<{builderAsset: SerializedBuilderAsset, builderPreferences: BuilderPreferences}>(`api/Share/SharedSlide?shareId=${shareId}`),
    getCustomSlideBackgroundImageUrl: (shareId: string) => WebClient.Get<{url: string}>(`api/Share/SlideBackground/${shareId}`),
    share: (libraryAssetId: string) => WebClient.Put.Unvalidated(`api/Share/Share`, { libraryAssetId }, deserializeLibraryItem),
    unshare: (libraryAssetId: string) => WebClient.Put.Unvalidated(`api/Share/UnShare`, { libraryAssetId }, deserializeLibraryItem),
    createUserShareItem: (id: string) => WebClient.Post.Unvalidated("api/Share/CreateUserSharedAsset/", {builderAssetId: id}, deserializeShareItem),
    getUserShareItem: (id: string) => WebClient.Get<ShareItem | null>(`api/Share/GetUserSharedAsset/${id}`, (item) => item ? deserializeShareItem(item) : null),
    getUserSharePreference: () => WebClient.Get<UserSharePreference | null>(`api/Share/GetUserSharedPreference/`),
    saveUserSharePreferences: (subdomain: string) => WebClient.Post.Validated<UserSharePreference>(`api/Share/SaveUserSharePreferences/`, {subdomain}),
    saveAssetShare: (request:SaveShareRequest) => WebClient.Post.Unvalidated(`api/Share/SaveAssetShare/`, request, deserializeShareItem),
}